import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from "@angular/router";
import { EMPTY, Observable, switchMap } from "rxjs";
import { IMapBoundsParams } from "src/app/models/map/map.model";
import { MapDataService } from "src/services/map/map-data.service";

export const TopographyMapResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> => {
    const mapDataService = inject(MapDataService);

    const bounds: IMapBoundsParams = {
        minLatitude: Number(route.queryParams["latMin"]),
        maxLatitude: Number(route.queryParams["latMax"]),
        minLongitude: Number(route.queryParams["longMin"]),
        maxLongitude: Number(route.queryParams["longMax"]),
    };
    const colorize = route.queryParams["colorize"] != null ? route.queryParams["colorize"] === "true" : null;

    return mapDataService.getTopographyMapUrl(bounds, colorize).pipe(
        switchMap((url) => {
            window.open(url, "_self");
            return EMPTY;
        }),
    );
};
